core.directive('floatingSelect', ['$parse', '$timeout',
    function($parse, $timeout) {
        var definition = {
            restrict: 'E',
            scope: {
                items: '=',
                onDismiss: '&',
                onItemSelected: '&',
                visible: '='
            },
            templateUrl: 'core/application/directive/floatingSelect/template/floating-select.html',
            link: function(scope, element, attr) {
                var parse = $parse(scope.label);
                var visibleDelayed = false;

                $(document).click(function(event) {
                    if(scope.visible && visibleDelayed && !$(event.target).closest('.floating-select-container').length) {
                        scope.onDismiss();
                        scope.$apply();
                    }
                });

                scope.$watch('visible', function (newVal) {
                    $timeout(function () {
                        visibleDelayed = newVal;
                    });
                });


            }
        };

        return definition;
    }
]);